import React, { useState, memo } from "react";
import { Button } from "react-bootstrap";
import ModalGestionBloqueos from "./ModalGestionBloqueos";

const GestorBloqueosButton = ({ canchas, onBloqueoCreado, puedeGestionar }) => {
  const [show, setShow] = useState(false);

  if (!puedeGestionar) return null;

  return (
    <>
      <Button
        variant="primary"
        className="ms-2"
        onClick={() => setShow(true)}
      >
        Gestionar Bloqueos
      </Button>
      <ModalGestionBloqueos
        show={show}
        onHide={() => setShow(false)}
        canchas={canchas}
        onBloqueoCreado={onBloqueoCreado}
      />
    </>
  );
};

export default memo(GestorBloqueosButton);
